<template>
    <div class="language">
        <el-dropdown class="user-name" trigger="click" @command="handleLanguage">
                    <span class="el-dropdown-link">
                          {{$t("navbar.language")}}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh">中文</el-dropdown-item>
                <el-dropdown-item divided command="en">English</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
export default {
    name: "Language",
    methods:{
        //切换语言
        handleLanguage(command){
            if(command === 'en'){
                this.$i18n.locale = 'en'
                localStorage.setItem('language','en')
            }else if(command === 'zh'){
                this.$i18n.locale = 'zh'
                localStorage.setItem('language','zh')
            }
        },
    }
}
</script>

<style scoped lang="stylus">
.language
    text-align right
    cursor: pointer;
    position absolute
    right 2rem
    top 1rem
</style>
